import isNil from "lodash/fp/isNil";

class Controller {
  constructor($injector, $stateParams, BulkScriptsTransforms) {
    "ngInject";

    this.Lists = $injector.get("Lists");
    this.Events = $injector.get("Events");
    this.BulkScripts = $injector.get("BulkScripts");
    this.stateParams = $stateParams;

    this.categories = this.Lists.all.bulkScriptsCategories;
    this.paginateEvent = this.Events.getPaginateEvent("bulkscripts");
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;

    if (this.stateParams.action) {
      this.action = this.stateParams.action;
      this.actionCategory = this.categories.find(
        (category) => category.name === this.action
      );
      this.actionName = this.actionCategory ? this.actionCategory.title : "";
    }

    this.fields = BulkScriptsTransforms.fields;
    this.actionListParams = { action: this.action };
    this.bulkscriptActions = [
      { title: "Download CSV File", method: this.downloadCSV.bind(this) },
    ];
  }

  downloadCSV(item) {
    if (isNil(item)) return;
    this.BulkScripts.getFileUrl(item._id, {
      action: this.action,
    }).$promise.then(
      (response) => {
        window.open(response.url, "_blank");
      },
      (error) => {
        this.Events.emit(this.errorEvent, error.data);
      }
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bulkScripts/bulkScripts.controller.js